export const defaultLanguage = 'cs';

export const supportedLanguages = [
  {code: 'en', name: 'English', country: 'gb',},
  {code: 'cs', name: 'Čeština', country: 'cz',},
  {code: 'uk', name: 'Українська', country: 'ua',},
];

const context = require.context('../../i18n', true, /\.json$/);

const translations = {};

context.keys().forEach((key) => {
  const match = key.match(/^\.\/([^/]+)\/([^/]+)\.json$/);
  if (!match) return;
  const [, langCode, namespace] = match;
  const fileData = context(key);
  
  if (!translations[langCode]) {
    translations[langCode] = {};
  }
  
  // Додаємо дані під іменем простору назв (наприклад, translations.uk.editor)
  // та також у корінь для сумісності з поточним кодом, який не використовує неймспейси
  translations[langCode][namespace] = fileData;
  
  translations[langCode] = {
    ...translations[langCode],
    ...fileData
  };
});

supportedLanguages.forEach(({code}) => {
  if (!translations[code]) {
    console.warn(
      `[i18n] Не знайдено жодного json-файлу для мови "${code}" у папці src/i18n/${code}/. ` +
        `Перевірте, що файли існують за цим шляхом.`
    );
  }
});

export {translations};